import React from 'react';
import { useParams } from 'react-router-dom';
import ProjectsList from './ProjectsList';
import ProjectDetail from './ProjectDetail';
import './Projects.css';

const Projects: React.FC = () => {
  const { projectSlug } = useParams<{ projectSlug?: string }>();

  return projectSlug ? <ProjectDetail /> : <ProjectsList />;
};

export default Projects;
